module.exports = __webpack_public_path__ + "img/slider.2c2a49b3.jpg";